import axios, { AxiosResponse } from "axios";
import { IAreaConhecimento, IOcupacaoPrincipal } from "../Interfaces/Interfaces";
import { errorMessage } from "../utils/messages";
import { ITipoFuncao } from "../views/OutroCargo/Componentes/InterfaceOutroCargo";
import { keycloakInterceptor } from "../auth/keycloakService";
import { ICaracteristicasMandato, IEnumCondicaoValidade, IFuncaoEspecialMandato } from "../views/Mandato/Componentes/InterfaceMandato";
import { IPepSituacao } from "../views/PessoaFisica/Componentes/InterfacePessoaFisica";

export const apiAuxiliar = axios.create({
  baseURL: process.env.REACT_APP_URL_API_CAND,
});
apiAuxiliar.interceptors.request.use(keycloakInterceptor);


// Retorna todas as áreas de conhecimento
export const getAreasConhecimento = async (setAreasConhecimento: React.Dispatch<React.SetStateAction<IAreaConhecimento[]>>, setLoading: React.Dispatch<React.SetStateAction<boolean>>) => {

  try {
    setLoading(true);
    await apiAuxiliar.get("/auxiliar/tabelas/areas").then((response) => {
      setAreasConhecimento(response?.data);
    });
  } catch (error: any) {
    errorMessage("Erro ao buscar lista de áreas de conhecimento. Se o erro persisitir entre em contato com o administrador do sistema.")
  } finally {
    setLoading(false);
  }
};

// Retorna todas os tipos de função para outros cadastros
export const getTiposFuncoes = async (setTiposFuncoes: React.Dispatch<React.SetStateAction<ITipoFuncao[]>>, setLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  setLoading(true);
  try {
    await apiAuxiliar.get("/auxiliar/tabelas/tipo-funcao-outros-cargos").then((response) => {
      setTiposFuncoes(response?.data);
    });
  } catch (error: any) {
    errorMessage("Erro ao buscar lista de tipos de função. Se o erro persisitir entre em contato com o administrador do sistema.")
  } finally {
    setLoading(false);
  }
};

let grausInstrucao:any[] = [];
export const obterGrausInstrucao = async():Promise<any[]> => {
  if (grausInstrucao.length === 0){
    let { data } = await apiAuxiliar.get<any[]>("/auxiliar/enums/grauinstrucao");
    grausInstrucao = data;
  }
  return grausInstrucao;
}

export const obterOrigens = ():Promise<AxiosResponse<any[], any>> => {
  return apiAuxiliar.get<any[]>("/auxiliar/enums/origens");
}

export const obterTipoPenalidades = ():Promise<AxiosResponse<any[], any>> => {
  return apiAuxiliar.get<any[]>("/auxiliar/enums/tipoPenalidades");
}

export const obterAreas = ():Promise<AxiosResponse<IAreaConhecimento[], any>> => {
  return apiAuxiliar.get<IAreaConhecimento[]>("/auxiliar/tabelas/areas");
}

export const obterOcupacoes = ():Promise<AxiosResponse<IOcupacaoPrincipal[], any>> => {
  return apiAuxiliar.get<IOcupacaoPrincipal[]>("/auxiliar/tabelas/ocupacoes");
}

export const obterPepSituacoes = ():Promise<AxiosResponse<IPepSituacao[], any>> => {
  return apiAuxiliar.get<IPepSituacao[]>("/auxiliar/tabelas/pepsituacoes");
}

export const obterFuncoesEspeciais = ():Promise<AxiosResponse<IFuncaoEspecialMandato[], any>> => {
  return apiAuxiliar.get<IFuncaoEspecialMandato[]>("/auxiliar/tabelas/funcao-especial");
}

export const obterCaracteristicasDiretor = ():Promise<AxiosResponse<ICaracteristicasMandato[], any>> => {
  return apiAuxiliar.get<ICaracteristicasMandato[]>("/auxiliar/tabelas/caracteristicas-mandato/1");
}
export const obterCaracteristicasConselheiro = ():Promise<AxiosResponse<ICaracteristicasMandato[], any>> => {
  return apiAuxiliar.get<ICaracteristicasMandato[]>("/auxiliar/tabelas/caracteristicas-mandato/5");
}

export const obterCondicaosValidade = ():Promise<AxiosResponse<IEnumCondicaoValidade[], any>> => {
  return apiAuxiliar.get<IEnumCondicaoValidade[]>("/auxiliar/enums/condicaovalidade");
}
